import {useNavigate} from 'react-router-dom';
import {useIsChatEnabledQuery} from '../services/chatService';

export interface OpenDirectChatLocationState {
    openDirectWithUserId: string;
}

export const useOpenDirectChat = () => {
    const navigate = useNavigate();
    const {data: isChatEnabled} = useIsChatEnabledQuery();

    return (appUserId: string | number | null | undefined) => {
        if (isChatEnabled === false || appUserId === null || appUserId === undefined || appUserId === '') return;

        const state: OpenDirectChatLocationState = {openDirectWithUserId: String(appUserId)};
        navigate('/chat', {state});
    };
};

export interface OpenChatMessageLocationState {
    openChatMessage: {roomId: string; eventId?: string};
}
